import { isKey } from "@grozav/utils";
import { OverlayController } from "@inkline/inkline/controllers";
export const OverlayPlugin = {
  install: () => {
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", (e) => {
        if (isKey("esc", e)) {
          OverlayController.onPressEscape();
        }
      });
    }
  }
};
